import { useMutation } from '@tanstack/react-query';

import { scoutClient } from '@/modules/scout-sourcing/scoutClient';
import type {
  PersonaVoteRecord,
  ScoutNextRoundResponse,
} from '@/modules/scout-sourcing/types';

type Payload = {
  jobId: string;
  jobSourcingId: string;
  votesForPreviousRound: PersonaVoteRecord[] | null;
};

export const useNextTargetingRoundMutation = () =>
  useMutation<ScoutNextRoundResponse, Error, Payload>({
    mutationFn: ({ jobId, jobSourcingId, votesForPreviousRound }) =>
      scoutClient.nextRound(jobId, jobSourcingId, votesForPreviousRound),
  });
